import { CouponTypes } from "../consts";
import { LOCAL_TRANS_FEE } from "../config-global";

// TODO - this all need to move to shared library (which currently make problems)

export const getTicketOriginalPrice = (tickets, chosenTicketId, coupon) => {
    const chosenTicket = tickets.find(ticket => ticket._id === chosenTicketId)
    if (chosenTicket) {
        return chosenTicket.price
        // return getTotalToPayAfterCoupon(chosenTicket.price, coupon, 1)
    }
    return 0
}

export const getTotalToPayAfterCoupon = (totalToPay, coupon, totalAmountOfTickets) => {
    if (!coupon) {
        return totalToPay
    }
    if (coupon.type === CouponTypes.FIXED) {
        const amountAfterDiscount = totalToPay - (coupon.amount * totalAmountOfTickets)
        return amountAfterDiscount < 0 ? 0 : amountAfterDiscount
    }
    if (coupon.type === CouponTypes.PERCENTAGE) {
        const amountByPercentage = coupon.amount
        const decimal = amountByPercentage / 100
        const discountAmount = decimal * totalToPay
        const amountAfterDiscount = Number((totalToPay - discountAmount).toFixed(0))
        return amountAfterDiscount < 0 ? 0 : amountAfterDiscount    
    }
    if (coupon.type === CouponTypes.CUSTOM_PRICE) {
        return coupon.amount * totalAmountOfTickets
    }
    return 'N/A'

}


export const getTotalOrderAmount = (userEvents, getTicket) => userEvents.reduce((acc, userEvent) => {
    if (!userEvent) {
        return acc + 0
    }

    if (userEvent.ticketsInfo?.length) {
        return userEvent.ticketsInfo.reduce((innerAccumulator, ticketInfo) => {
            return innerAccumulator + (ticketInfo.originalPrice || 0)
        }, acc)
    }
    // This is legacy, when we saved the ticket on the userEvent and not on the ticketInfo
    const ticket = getTicket(userEvent.ticket)
    return acc + (ticket?.price || 0)
}, 0)

export const getRefundAmount = (totalOrderAmount, amountLeftAfterAllRefunds) => {
    
    if (amountLeftAfterAllRefunds || amountLeftAfterAllRefunds === 0) {
        const amountLeftAfterAllRefundsNumber = Number(amountLeftAfterAllRefunds) / 100
        return totalOrderAmount - amountLeftAfterAllRefundsNumber
    }
    return 0
}

export const getNimiFee = (marketFee) => {
    const VAT = 1.17 // TODO, need to change in the future to present VAT dynamically by country
    if (!marketFee) {
        return
    }
    // We extract the VAT from the fee amount to present the seller the price of the clean commission without the VAT
    return (Number(marketFee) / VAT).toFixed(2)
}

export const getTotalTicketsAmount = (allUsersEvent) => {
    return allUsersEvent.reduce((acc, userEvent) => {
        // For user-event per one ticket.
        if (!userEvent?.ticketsInfo?.length) {
            return acc + 1
        }
        // For user-event per many ticket.
        return acc + userEvent.ticketsInfo.length
    }, 0)
}
